import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyStoreComponent } from './company-store.component';
import { Route, RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { PackageBuyModalModule } from 'app/common/components/package-buy-modal/package-buy-modal.module';
import { KCompanyItemCardModule } from 'app/common/ui/k-cards/k-company-item-card/k-company-item-card.module';

const routes: Route[] = [
  {
    path: '',
    component: CompanyStoreComponent,
    outlet: 'company-store'
  }
];

@NgModule({
  declarations: [
    CompanyStoreComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PackageBuyModalModule,
    KCompanyItemCardModule,
    // TranslocoModule
  ],
  exports: [
    CompanyStoreComponent
  ]
})
export class CompanyStoreModule { }
